const EwsStatusColor = [
  {
    label: 'อพยพ',
    statusColor: '#FF2D2E',
    constrastColor: '#FFF',
    fontSize: '12px',
  },
  {
    label: 'เตือนภัย',
    statusColor: '#CC9903',
    constrastColor: '#FFF',
    fontSize: '12px',
  },
  {
    label: 'เฝ้าระวัง',
    statusColor: '#029900',
    constrastColor: '#FFF',
    fontSize: '12px',
  },
];

export default EwsStatusColor;
